import { render, staticRenderFns } from "./after.vue?vue&type=template&id=44be0feb&scoped=true"
import script from "./after.vue?vue&type=script&lang=js"
export * from "./after.vue?vue&type=script&lang=js"
import style0 from "./after.vue?vue&type=style&index=0&id=44be0feb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be0feb",
  null
  
)

export default component.exports